import { PortalToRoot } from '@ipfabric/ui-components/PortalToRoot/PortalToRoot';
import { prop } from '@ipfabric/utils/fp/prop';
import { ContextMenu } from 'components/DropdownMenu/ContextMenu';
import { useTableContextSelectors } from 'components/Table/model/TableModel';
import { setTableContextMenu } from 'components/Table/model/commands/setTableContextMenu';
import { setTableRowDetail } from 'components/Table/model/commands/setTableRowDetail';
import { useLocale } from 'containers/App/LocaleContext';
import type { FC } from 'react';

export const TableContextMenu: FC = () => {
  const {
    table: { contextMenu: contextMenuMsg },
  } = useLocale();
  const ctxProps = useTableContextSelectors({
    dispatch: prop('dispatch'),
    tableContextMenu: prop('tableContextMenu'),
  });

  const handleClose = () => {
    ctxProps.dispatch(setTableContextMenu, { state: null });
  };

  return (
    ctxProps.tableContextMenu && (
      <PortalToRoot>
        <ContextMenu
          position={ctxProps.tableContextMenu.position}
          onClose={handleClose}
          items={[
            {
              label: contextMenuMsg.showDetail,

              onClick: () => {
                ctxProps.dispatch(setTableRowDetail, {
                  index: ctxProps.tableContextMenu!.index,
                });
              },
            },
          ]}
        />
      </PortalToRoot>
    )
  );
};
